import React from 'react';
import Alert from '@mui/material/Alert';

export const renderError = (message) => <Alert severity="error">{message}</Alert>;
